export default __webpack_public_path__ + "static/media/img-main_banner.0146086a.jpg";